document.addEventListener('DOMContentLoaded', function() {
  // Function to check if element is in viewport
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.bottom >= 0
    );
  }
  
  // Load scripts based on user interaction
  let hasInteracted = false;
  const interactionEvents = ['mousedown', 'keydown', 'touchstart', 'scroll'];
  
  function onInteraction() {
    if (hasInteracted) return;
    hasInteracted = true;
    
    // Remove event listeners
    interactionEvents.forEach(event => {
      window.removeEventListener(event, onInteraction, { passive: true });
    });
    
    // Load non-critical scripts
    const deferredScripts = document.querySelectorAll('script[data-defer-load="true"]');
    deferredScripts.forEach(script => {
      const newScript = document.createElement('script');
      [...script.attributes]
        .filter(attr => attr.name !== 'data-defer-load' && attr.name !== 'data-src')
        .forEach(attr => newScript.setAttribute(attr.name, attr.value));
      
      newScript.src = script.getAttribute('data-src');
      script.parentNode.replaceChild(newScript, script);
    });
  }
  
  // Add event listeners for user interaction
  interactionEvents.forEach(event => {
    window.addEventListener(event, onInteraction, { passive: true });
  });
  
  // Fallback: Load after a delay if no interaction
  setTimeout(onInteraction, 5000);
});